import { PoolName } from "@/shared/constants/pools";
import { ChainName } from "@/shared/types/networks";

import { ArbitrumActivePools } from "../constants/active-pools";
import {
  uniswapPoolArbUsdcArbitrum,
  uniswapPoolArbUsdcNativeArbitrum,
  uniswapPoolWbtcWethArbitrum,
  uniswapPoolWethUsdcArbitrum,
  uniswapPoolWethUsdcNativeArbitrum,
} from "../constants/pools/arbitrum";
import { ParamsByBoolName, PoolParams } from "../types";

const paramsByPoolNameArbitrum: Record<ArbitrumActivePools, PoolParams> = {
  [PoolName.ArbUsdc]: uniswapPoolArbUsdcArbitrum,
  [PoolName.WethUsdc]: uniswapPoolWethUsdcArbitrum,
  [PoolName.WbtcWeth]: uniswapPoolWbtcWethArbitrum,
  [PoolName.ArbUsdce]: uniswapPoolArbUsdcNativeArbitrum,
  [PoolName.WethUsdce]: uniswapPoolWethUsdcNativeArbitrum,
};

const poolsByChainName: Record<ChainName, ParamsByBoolName> = {
  [ChainName.Arbitrum]: paramsByPoolNameArbitrum,
  [ChainName.ArbitrumGoerli]: {},
  [ChainName.PolygonMumbai]: {},
};

export const getUniswapPoolParams = (
  poolName: PoolName,
  chainName: ChainName,
) => {
  const pools = poolsByChainName[chainName];
  return pools[poolName];
};
